module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DB79_1SB_GJI.560cf55f.png";